import { twMerge } from 'tailwind-merge';
import type { ScanServiceType } from '@witmetrics/utils';
import { SCAN_SERVICE_TYPE_COLORS } from '@witmetrics/unison-core';
import Icon from '@/components/Icon';
import { ICONS } from './constants';
import { classes } from './utils';

export type ServiceTypeIconProps = {
  className?: string;
  iconClassName?: string;
  serviceType: ScanServiceType;
};

export default function ServiceTypeIcon({
  className,
  iconClassName,
  serviceType,
}: ServiceTypeIconProps) {
  const colors =
    SCAN_SERVICE_TYPE_COLORS[serviceType] || SCAN_SERVICE_TYPE_COLORS.DEFAULT;

  const CaseIcon = ICONS[serviceType] || ICONS.DEFAULT;

  return (
    <Icon
      className={twMerge(classes.wrapper, className)}
      icon={<CaseIcon className={twMerge(classes.icon, iconClassName)} />}
      color="white"
      borderColor={null}
      backgroundColor={colors.fill}
    />
  );
}
